module.exports = {
  title: '产品品牌详情',
  route: {
    path: 'platform-goods-manage',
    children: {
      path: 'product-brand-form',
    },
  },
};
